// 请求接口地址定义
export const CLOUD_URL =
	process.env.NODE_ENV === 'production'
		? '//cloud.che300.com/'
		: '//cloud.ceshi.che300.com/'

// 请求接口地址定义
export const WWW_URL =
	process.env.NODE_ENV === 'production'
		? 'http://www.sanbaiyun.com/'
		: 'http://www.ceshi.sanbaiyun.com/'
		//三百云暂不支持https


// 登陆页面地址
export const LOGIN_URL =
	process.env.NODE_ENV === 'production'
		? 'https://login.che300.com/ucenter/login'
		: 'http://login.ceshi.che300.com/ucenter/login'

// 手机号验证
export const validMobileFormat = function (mobile) {
	var numberRegStr = /^\d{11}$/
	var regNum = new RegExp(numberRegStr)
	if (regNum.test(mobile)) {
		var telRegStr = /^(13|14|18|15|17|16|19)\d{9}$/
		var reg = new RegExp(telRegStr)
		return reg.test(mobile)
	} else {
		return false
	}
}

// 节流函数封装（传handle函数，以及延迟）
export const throttle = function(func, delay) {
    var prev = Date.now();
    return function() {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - prev >= delay) {
            func.apply(context, args);
            prev = Date.now();
        }
    };
};

/**
 * 顶项验证的id验证码
 */
export const verifyTokenConfig = {
    appId: 'f780acccd6e391d352f2076600d5aa16'
};


// WEBPACK FOOTER //
// ./src/utils/constant.js